import { FeatureFlagCollection } from './feature-flag.interface';

export type E2eFeatureFlagOverrideMap = Partial<Record<FeatureFlagCollection, boolean>>;

export interface IE2eFeatureFlagOverride {
  _id?: string;
  userId: string;
  flags: E2eFeatureFlagOverrideMap;
  createdAt?: Date;
  updatedAt?: Date;
}

export const $e2eFeatureFlagOverride = {
  _id: '_id',
  userId: 'userId',
  flags: 'flags',
} as const;

export interface IE2eFeatureFlagOverrideTenant {
  _id?: string;
  tenantId: string;
  flags: E2eFeatureFlagOverrideMap;
  createdAt?: Date;
  updatedAt?: Date;
}

export const $e2eFeatureFlagOverrideTenant = {
  _id: '_id',
  tenantId: 'tenantId',
  flags: 'flags',
} as const;

export const E2E_FF_ANONYMOUS_OVERRIDES_STORAGE_KEY = 'e2e-ff-overrides-anonymous';
